import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { Container } from "react-bootstrap";
import { isBrowser } from "react-device-detect";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import TransportManagementHome from "../components/TransportManagement/TransportManagementHome";

class TransportManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      Cookies.set("toggle", "wrapper");
    }
    this.forceUpdate();
  };

  render() {
    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser
                ? "sidebar-menu d-none d-xl-block d-lg-block"
                : "sidebar-menu d-block d-xl-none d-lg-none"
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <Container fluid>
              <TransportManagementHome />
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(withApollo(compose()(TransportManagement)));
